import { IconButton, IconButtonProps } from '@material-ui/core'
import CreateIcon from '@material-ui/icons/Create'
import { blueGray, dividerGray, lightGray2, midGray, royalBlue } from 'shared/theme/colors'
import styled from 'styled-components'

interface EditButtonProps {
  padding?: string | number
  className?: string
  onClick?: IconButtonProps['onClick']
  ariaLabel: string
}

interface BlueEditTextButtonProps {
  ariaLabel: string
  onClick: () => void
  className?: string
}

export const EditButton = (props: EditButtonProps) => {
  return (
    <StyledIconButton
      aria-label={props.ariaLabel}
      className={props.className}
      $padding={props.padding}
      onClick={props.onClick}
    >
      <CreateIcon style={{ color: lightGray2 }} />
    </StyledIconButton>
  )
}

export const BlueEditTextButton = (props: BlueEditTextButtonProps) => {
  return (
    <StyledBlueButton aria-label={props.ariaLabel} onClick={props.onClick} className={props.className}>
      Edit
    </StyledBlueButton>
  )
}

const StyledIconButton = styled(IconButton)<{ $padding?: string | number }>`
  padding: ${(p) => p.$padding || '6px'};

  &:hover {
    color: ${royalBlue};
  }
`

export const GreyEditButton = styled(EditButton)`
  color: ${dividerGray};

  svg {
    width: 18px;
    height: 18px;
    color: ${dividerGray} !important;
    transition: color 0.3s;
  }

  &:hover svg {
    color: ${midGray} !important;
  }
`

export const BlueGreyEditButton = styled(EditButton)`
  color: ${blueGray};

  svg {
    width: 18px;
    height: 18px;
    color: ${blueGray} !important;
    transition: color 0.3s;
  }

  &:hover svg {
    color: ${blueGray} !important;
  }
`

export const StyledBlueButton = styled.button`
  background: none;
  border: none;
  color: blue;
  cursor: pointer;
  text-decoration: none;
  font-size: 16px;
  padding: 0;

  &:hover {
    color: darkblue !important;
  }
`
